import { PatientAuthorization } from '../types';

export const formatPatientAuthorizationName = (patientAuthorization: PatientAuthorization): string => {
   return `${patientAuthorization.firstName.asString()} ${patientAuthorization.lastName.asString()}`;
};
